import React, { useState, createContext, useContext } from 'react';
import MainLayout from './layout/MainLayout';
import Dashboard   from './pages/Dashboard/Dashboard';
import Books       from './pages/Books/Books';
import AddBook     from './pages/AddBook/AddBook';
import Members     from './pages/Members/Members';
import IssueReturn from './pages/IssueReturn/IssueReturn';
import Collection  from './pages/Collection/Collection';
import Reports     from './pages/Reports/Reports';
import Settings    from './pages/Settings/Settings';
import Users       from './pages/Users/Users';
import Profile     from './pages/Profile/Profile';
import HelpCenter  from './pages/HelpCenter/HelpCenter';
import AlertModal  from './components/Modal/AlertModal';
import Login       from './pages/Login/Login';
import Chatbot     from './components/Chatbot/Chatbot';
import PublicHome  from './public/PublicHome/PublicHome';
import Blogs       from './pages/Blogs/Blogs';
import Notices     from './pages/Notices/Notices';
import QuestionPapers from './pages/QuestionPapers/QuestionPapers';
import { useAuth } from './context/AuthContext';
import './styles/global.css';

const ModalContext = createContext();
export const useModal = () => useContext(ModalContext);

function App() {
  const [navigation, setNavigation] = useState({ page: 'dashboard', params: null });
  const [modal, setModal] = useState({ isOpen: false, type: 'info', title: '', message: '', onConfirm: null });

  const navigateTo = (page, params = null) => {
    setNavigation({ page, params });
  };

  const showAlert = (title, message, type = 'info', onConfirm = null) => {
    setModal({
      isOpen: true, title, message, type,
      onConfirm: () => { 
        onConfirm?.(); 
        setModal(p => ({ ...p, isOpen: false })); 
      }
    });
  };

  const showConfirm = (title, message, onConfirm) => {
    setModal({
      isOpen: true, title, message, type: 'confirm',
      onConfirm: () => { 
        onConfirm(); 
        setModal(p => ({ ...p, isOpen: false })); 
      }
    });
  };

  const renderPage = () => {
    const props = { showAlert, showConfirm, onNavigate: navigateTo };
    switch (navigation.page) {
      case 'dashboard':    return <Dashboard {...props} />;
      case 'books':        return <Books {...props} />;
      case 'add-book':     return <AddBook {...props} editId={navigation.params?.edit} />;
      case 'members':      return <Members {...props} />;
      case 'issue-return': return <IssueReturn {...props} />;
      case 'collection':   return <Collection {...props} />;
      case 'reports':      return <Reports {...props} />;
      case 'settings':     return <Settings {...props} />;
      case 'blogs':        return <Blogs {...props} />;
      case 'notices':      return <Notices {...props} />;
      case 'question-papers': return <QuestionPapers {...props} />;
      case 'users':        
        if (user?.role !== 'Admin') return <Dashboard {...props} />;
        return <Users {...props} />;
      case 'profile':      return <Profile {...props} />;
      case 'help':         return <HelpCenter {...props} />;
      default:             return <Dashboard {...props} />;
    }
  };

  const sidebarPage = navigation.page === 'add-book' ? 'books' : navigation.page;

  const { user, loading } = useAuth();
  const [showLogin, setShowLogin] = useState(false);

  if (loading) {
    return <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Loading application...</div>;
  }

  if (!user) {
    if (showLogin) return <Login onBack={() => setShowLogin(false)} />;
    return <PublicHome onLoginClick={() => setShowLogin(true)} />;
  }

  return (
    <ModalContext.Provider value={{ showAlert, showConfirm }}>
      <>
        <MainLayout activePage={sidebarPage} onNavigate={navigateTo}>
          {renderPage()}
        </MainLayout>

        <AlertModal 
          isOpen={modal.isOpen} 
          {...modal} 
          onCancel={() => setModal(p => ({ ...p, isOpen: false }))} 
        />
        <Chatbot />
      </>
    </ModalContext.Provider>
  );
}

export default App;
